export default __webpack_public_path__ + "static/media/assetSample8@2x.0c152122.png";